import React from 'react';
import { Badge } from 'src/design/atoms/Badge';
import { DownloadActionIcon } from 'src/design/atoms/DownloadActionIcon';
import { EmptyState } from 'src/design/atoms/EmptyState';
import { Group } from 'src/design/atoms/Group';
import { Stack } from 'src/design/atoms/Stack';
import { Text } from 'src/design/atoms/Text';
import { DocumentVersionDto } from 'src/api/FiretrolApiClient';
import { useDownloadDocumentVersion } from 'src/api/queries/documents/useDocumentDownload';
import { userDisplayName } from 'src/app/documents/documentAccess';
import { formatDateTime } from 'src/utils';

export interface IVersionListProps {
  jobId: number;
  versions: DocumentVersionDto[];
  currentUserId?: number;
}

export const VersionList: React.FC<IVersionListProps> = ({
  jobId,
  versions,
  currentUserId,
}) => {
  const downloadVersion = useDownloadDocumentVersion();

  if (versions.length === 0) {
    return <EmptyState description="No earlier versions" />;
  }

  return (
    <Stack gap="xs">
      {versions.map((version, index) => {
        const uploader = userDisplayName(
          version.uploadedById,
          version.uploadedBy?.fullName,
          currentUserId,
        );

        return (
          <Group key={version.id} justify="space-between" wrap="nowrap">
            <Stack gap={0}>
              <Group gap="xs">
                <Text size="sm" fw={500} c="bright">
                  {`Version ${versions.length - index}`}
                </Text>
                {index === 0 && (
                  <Badge size="xs" variant="light">
                    Current
                  </Badge>
                )}
              </Group>
              <Text size="xs" c="dimmed">
                {`${uploader} · ${formatDateTime(
                  version.updatedAt,
                  'MMM D, YYYY h:mm A',
                )}`}
              </Text>
            </Stack>
            <DownloadActionIcon
              variant="subtle"
              label="Download this version"
              onClick={() =>
                downloadVersion.mutate({ jobId, versionId: version.id })
              }
            />
          </Group>
        );
      })}
    </Stack>
  );
};
